<div [attr.id]="id" class="ignite-alert">
  <div class="ignite-alert-title">
    <ng-content select="[alert-title]"></ng-content>
  </div>
  <div class="ignite-alert-content">
    <ng-content select="[alert-content]"></ng-content>
  </div>
</div>
